require('./bootstrap');
window.Vue = require('vue').default;

import Vuetify from 'vuetify';
Vue.use(Vuetify);

import Vuex from 'vuex';
Vue.use(Vuex);

import DatetimePicker from 'vuetify-datetime-picker';
Vue.use(DatetimePicker);

import VueRouter from 'vue-router';
Vue.use(VueRouter);

const store = new Vuex.Store({
    state: {
        adminNavDrawer: false,
        selectedNavItem: -1,
        manager: null,
        statusText: null,
        isShowStatus: false,
        errorText: null,
        isShowError: false,
        navs: [],
        isReloadDataTable: false,
        numberNotApproveComments: 0,
        numberNotReadMessages: 0,
        needVerifyNumber: 0,
        numberGamesNotHaveCategory: 0,
    },
    mutations: {
        updateNumberGamesNotHaveCategory (state, value) {
            state.numberGamesNotHaveCategory = value;
        },
        updateNeedVerifyNumber (state, value) {
            state.needVerifyNumber = value;
        },
        updateNumberNotReadMessages (state, value) {
            state.numberNotReadMessages = value;
        },
        updateNumberNotApproveComments (state, value) {
            state.numberNotApproveComments = value;
        },
        updateIsReloadDataTable (state, value) {
            state.isReloadDataTable = value;
        },
        updateNavs (state, value) {
            state.navs = value;
        },
        updateIsShowError (state, value) {
            state.isShowError = value;
        },
        updateErrorText (state, value) {
            state.errorText = value;
        },
        updateIsShowStatus (state, value) {
            state.isShowStatus = value;
        },
        updateStatusText (state, value) {
            state.statusText = value;
        },
        updateManager (state, value) {
            state.manager = value;
        },
        updateSelectedNavItem (state, value) {
            state.selectedNavItem = value;
        },
        updateAdminNavDrawer (state, value) {
            state.adminNavDrawer = value;
        },
    }
});

Vue.component('login', function (resolve) {
    require(['./components/auth/Login'], resolve)
});
Vue.component('base-layout', function (resolve) {
    require(['./components/BaseLayout'], resolve)
});
Vue.component('main-nav', function (resolve) {
    require(['./components/Nav/Nav.vue'], resolve)
});
Vue.component('main-nav-list', function (resolve) {
    require(['./components/Nav/NavList.vue'], resolve)
});
Vue.component('system-alert', function (resolve) {
    require(['./components/SystemAlert.vue'], resolve)
});
Vue.component('app-bar', function (resolve) {
    require(['./components/AppBar.vue'], resolve)
});
Vue.component('cyrillic-filter-input', function (resolve) {
    require(['./components/inputs/CyrillicFilterInput'], resolve)
});
Vue.component('password-input', function (resolve) {
    require(['./components/inputs/PasswordInput'], resolve)
});
Vue.component('phone-input', function (resolve) {
    require(['./components/inputs/PhoneInput'], resolve)
});
Vue.component('date-time-input', function (resolve) {
    require(['./components/inputs/DateTimeInput'], resolve)
});
Vue.component('image-loader', function (resolve) {
    require(['./components/inputs/ImageLoader'], resolve)
});
Vue.component('search-data-table', function (resolve) {
    require(['./components/SearchDataTable'], resolve)
});
Vue.component('data-table', function (resolve) {
    require(['./components/DataTable'], resolve)
});
Vue.component('camera', function (resolve) {
    require(['./components/inputs/Camera'], resolve)
});
Vue.component('main-nav', function (resolve) {
    require(['./components/Nav/Nav.vue'], resolve)
});
Vue.component('main-nav-list', function (resolve) {
    require(['./components/Nav/NavList.vue'], resolve)
});
Vue.component('settings-text', function (resolve) {
    require(['./components/settings/TextProperty'], resolve)
});
Vue.component('settings-bool', function (resolve) {
    require(['./components/settings/BoolProperty'], resolve)
});

const index = () => import('./components/Index');
const pageNotFound = () => import('./components/PageNotFound');
const ManagerIndex = () => import('./components/manager/ManagerIndex');
const ManagerCreate = () => import('./components/manager/ManagerCreate');
const ManagerEdit = () => import('./components/manager/ManagerEdit');
const SettingsMain = () => import('./components/settings/SettingsMain');
const MainSliders = () => import('./components/settings/MainSliders');
const SeoIndex = () => import('./components/seo/SeoIndex');
const SeoCreate = () => import('./components/seo/SeoCreate');
const SeoEdit = () => import('./components/seo/SeoEdit');
const PaymentSystemIndex = () => import('./components/payment_system/PaymentSystemIndex');
const PaymentSystemCreate = () => import('./components/payment_system/PaymentSystemCreate');
const PaymentSystemEdit = () => import('./components/payment_system/PaymentSystemEdit');
const PaymentDirectionIndex = () => import('./components/payment_direction/PaymentDirectionIndex');
const PaymentDirectionEdit = () => import('./components/payment_direction/PaymentDirectionEdit');
const CategoryIndex = () => import('./components/category/CategoryIndex');
const CategoryCreate = () => import('./components/category/CategoryCreate');
const CategoryEdit = () => import('./components/category/CategoryEdit');
const ProviderIndex = () => import('./components/provider/ProviderIndex');
const ProviderCreate = () => import('./components/provider/ProviderCreate');
const ProviderEdit = () => import('./components/provider/ProviderEdit');
const GameIndex = () => import('./components/game/GameIndex');
const GameCreate = () => import('./components/game/GameCreate');
const GameEdit = () => import('./components/game/GameEdit');
const TournamentIndex = () => import('./components/tournament/TournamentIndex');
const TournamentCreate = () => import('./components/tournament/TournamentCreate');
const TournamentEdit = () => import('./components/tournament/TournamentEdit');
const BonusIndex = () => import('./components/bonus/BonusIndex');
const BonusCreate = () => import('./components/bonus/BonusCreate');
const BonusEdit = () => import('./components/bonus/BonusEdit');
const PromocodeIndex = () => import('./components/promocode/PromocodeIndex');
const PromocodeCreate = () => import('./components/promocode/PromocodeCreate');
const PromocodeEdit = () => import('./components/promocode/PromocodeEdit');
const FaqIndex = () => import('./components/faq/FaqIndex');
const FaqCreate = () => import('./components/faq/FaqCreate');
const FaqEdit = () => import('./components/faq/FaqEdit');
const RoleIndex = () => import('./components/role/RoleIndex');
const RoleCreate = () => import('./components/role/RoleCreate');
const RoleEdit = () => import('./components/role/RoleEdit');
const CommentIndex = () => import('./components/comment/CommentIndex');
const SupportIndex = () => import('./components/support/SupportIndex');
const UserIndex = () => import('./components/user/UserIndex');
const UserEdit = () => import('./components/user/UserEdit');
const PaymentIndex = () => import('./components/payment/PaymentIndex');
const LevelIndex = () => import('./components/level/LevelIndex');
const LevelCreate = () => import('./components/level/LevelCreate');
const LevelEdit = () => import('./components/level/LevelEdit');
const DomainIndex = () => import('./components/domain/DomainIndex');
const DomainCreate = () => import('./components/domain/DomainCreate');
const DomainEdit = () => import('./components/domain/DomainEdit');
const JackpotIndex = () => import('./components/jackpot/JackpotIndex');
const JackpotCreate = () => import('./components/jackpot/JackpotCreate');
const JackpotEdit = () => import('./components/jackpot/JackpotEdit');
const routes = [
    {
        path: '/',
        component: index,
        name: 'index',
        meta: {
            title: 'Arbuz Crm',
        }
    },
    {
        path: '/managers',
        component: ManagerIndex,
        name: 'ManagerIndex',
        meta: {
            title: 'Менеджеры',
        }
    },
    {
        path: '/manager/create/:parentQuery?',
        component: ManagerCreate,
        name: 'ManagerCreate',
        meta: {
            title: 'Создание менеджера',
        }
    },
    {
        path: '/manager/edit/:id/:parentQuery?',
        component: ManagerEdit,
        name: 'ManagerEdit',
        props: true,
        meta: {
            title: 'Редактирование менеджера',
        }
    },
    {
        path: '/settings/main',
        component: SettingsMain,
        name: 'SettingsMain',
        meta: {
            title: 'Основные настройки',
        }
    },
    {
        path: '/settings/main-slider',
        component: MainSliders,
        name: 'MainSliders',
        meta: {
            title: 'Слайдер',
        }
    },
    {
        path: '/seo',
        component: SeoIndex,
        name: 'SeoIndex',
        meta: {
            title: 'Seo',
        }
    },
    {
        path: '/seo/create/:parentQuery?',
        component: SeoCreate,
        name: 'SeoCreate',
        meta: {
            title: 'Создание seo',
        }
    },
    {
        path: '/seo/edit/:id/:parentQuery?',
        component: SeoEdit,
        name: 'SeoEdit',
        props: true,
        meta: {
            title: 'Редактирование seo',
        }
    },
    {
        path: '/payment-systems',
        component: PaymentSystemIndex,
        name: 'PaymentSystemIndex',
        meta: {
            title: 'Платежные системы',
        }
    },
    {
        path: '/paymentSystem/create/:parentQuery?',
        component: PaymentSystemCreate,
        name: 'PaymentSystemCreate',
        props: true,
        meta: {
            title: 'Создание платежной системы',
        }
    },
    {
        path: '/paymentSystem/edit/:id/:parentQuery?',
        component: PaymentSystemEdit,
        name: 'PaymentSystemEdit',
        props: true,
        meta: {
            title: 'Редактирование платежной системы',
        }
    },
    {
        path: '/payment-directions',
        component: PaymentDirectionIndex,
        name: 'PaymentDirectionIndex',
        meta: {
            title: 'Направления платежей',
        }
    },
    {
        path: '/paymentDirection/edit/:id/:parentQuery?',
        component: PaymentDirectionEdit,
        name: 'PaymentDirectionEdit',
        props: true,
        meta: {
            title: 'Редактирование направления платежа',
        }
    },
    {
        path: '/categories',
        component: CategoryIndex,
        name: 'CategoryIndex',
        meta: {
            title: 'Категории',
        }
    },
    {
        path: '/category/create/:parentQuery?',
        component: CategoryCreate,
        name: 'CategoryCreate',
        meta: {
            title: 'Создание категории',
        }
    },
    {
        path: '/category/edit/:id/:parentQuery?',
        component: CategoryEdit,
        name: 'CategoryEdit',
        props: true,
        meta: {
            title: 'Редактирование категории',
        }
    },
    {
        path: '/providers',
        component: ProviderIndex,
        name: 'ProviderIndex',
        meta: {
            title: 'Провайдеры',
        }
    },
    {
        path: '/provider/create/:parentQuery?',
        component: ProviderCreate,
        name: 'ProviderCreate',
        meta: {
            title: 'Создание провайдера',
        }
    },
    {
        path: '/provider/edit/:id/:parentQuery?',
        component: ProviderEdit,
        name: 'ProviderEdit',
        props: true,
        meta: {
            title: 'Редактирование провайдера',
        }
    },
    {
        path: '/games',
        component: GameIndex,
        name: 'GameIndex',
        meta: {
            title: 'Игры',
        }
    },
    {
        path: '/game/create/:parentQuery?',
        component: GameCreate,
        name: 'GameCreate',
        meta: {
            title: 'Создание игры',
        }
    },
    {
        path: '/game/edit/:id/:parentQuery?',
        component: GameEdit,
        name: 'GameEdit',
        props: true,
        meta: {
            title: 'Редактирование игры',
        }
    },
    {
        path: '/tournaments',
        component: TournamentIndex,
        name: 'TournamentIndex',
        meta: {
            title: 'Турниры',
        }
    },
    {
        path: '/tournament/create/:parentQuery?',
        component: TournamentCreate,
        name: 'TournamentCreate',
        meta: {
            title: 'Создание турнира',
        }
    },
    {
        path: '/tournament/edit/:id/:parentQuery?',
        component: TournamentEdit,
        name: 'TournamentEdit',
        props: true,
        meta: {
            title: 'Редактирование турнира',
        }
    },
    {
        path: '/bonuses',
        component: BonusIndex,
        name: 'BonusIndex',
        meta: {
            title: 'Акции и бонусы',
        }
    },
    {
        path: '/bonus/create/:parentQuery?',
        component: BonusCreate,
        name: 'BonusCreate',
        meta: {
            title: 'Создание акции или бонуса',
        }
    },
    {
        path: '/bonus/edit/:id/:parentQuery?',
        component: BonusEdit,
        name: 'BonusEdit',
        props: true,
        meta: {
            title: 'Редактирование акции или бонуса',
        }
    },
    {
        path: '/promocodes',
        component: PromocodeIndex,
        name: 'PromocodeIndex',
        meta: {
            title: 'Промокоды',
        }
    },
    {
        path: '/promocode/create/:parentQuery?',
        component: PromocodeCreate,
        name: 'PromocodeCreate',
        meta: {
            title: 'Создание промокода',
        }
    },
    {
        path: '/promocode/edit/:id/:parentQuery?',
        component: PromocodeEdit,
        name: 'PromocodeEdit',
        props: true,
        meta: {
            title: 'Редактирование промокода',
        }
    },
    {
        path: '/faqs',
        component: FaqIndex,
        name: 'FaqIndex',
        meta: {
            title: 'Вопросы и ответы',
        }
    },
    {
        path: '/faq/create/:parentQuery?',
        component: FaqCreate,
        name: 'FaqCreate',
        meta: {
            title: 'Создание вопроса',
        }
    },
    {
        path: '/faq/edit/:id/:parentQuery?',
        component: FaqEdit,
        name: 'FaqEdit',
        props: true,
        meta: {
            title: 'Редактирование вопроса',
        }
    },
    {
        path: '/roles',
        component: RoleIndex,
        name: 'RoleIndex',
        meta: {
            title: 'Роли',
        }
    },
    {
        path: '/role/create/:parentQuery?',
        component: RoleCreate,
        name: 'RoleCreate',
        meta: {
            title: 'Создание роли',
        }
    },
    {
        path: '/role/edit/:id/:parentQuery?',
        component: RoleEdit,
        name: 'RoleEdit',
        props: true,
        meta: {
            title: 'Редактирование роли',
        }
    },
    {
        path: '/comments',
        component: CommentIndex,
        name: 'CommentIndex',
        meta: {
            title: 'Отзывы',
        }
    },
    {
        path: '/supports',
        component: SupportIndex,
        name: 'SupportIndex',
        meta: {
            title: 'Поддержка',
        }
    },
    {
        path: '/payments',
        component: PaymentIndex,
        name: 'PaymentIndex',
        meta: {
            title: 'Выплаты',
        }
    },
    {
        path: '/users',
        component: UserIndex,
        name: 'UserIndex',
        meta: {
            title: 'Игроки',
        }
    },
    {
        path: '/user/edit/:id/:parentQuery?',
        component: UserEdit,
        name: 'UserEdit',
        props: true,
        meta: {
            title: 'Редактирование игрока',
        }
    },
    {
        path: '/levels',
        component: LevelIndex,
        name: 'LevelIndex',
        meta: {
            title: 'Уровни',
        }
    },
    {
        path: '/level/create/:parentQuery?',
        component: LevelCreate,
        name: 'LevelCreate',
        meta: {
            title: 'Создание уровня',
        }
    },
    {
        path: '/level/edit/:id/:parentQuery?',
        component: LevelEdit,
        name: 'LevelEdit',
        props: true,
        meta: {
            title: 'Редактирование уровня',
        }
    },
    {
        path: '/domains',
        component: DomainIndex,
        name: 'DomainIndex',
        meta: {
            title: 'Домены',
        }
    },
    {
        path: '/domain/create/:parentQuery?',
        component: DomainCreate,
        name: 'DomainCreate',
        meta: {
            title: 'Создание домена',
        }
    },
    {
        path: '/domain/edit/:id/:parentQuery?',
        component: DomainEdit,
        name: 'DomainEdit',
        props: true,
        meta: {
            title: 'Редактирование домена',
        }
    },
    {
        path: '/jackpots',
        component: JackpotIndex,
        name: 'JackpotIndex',
        meta: {
            title: 'Джекпоты',
        }
    },
    {
        path: '/jackpot/create/:parentQuery?',
        component: JackpotCreate,
        name: 'JackpotCreate',
        meta: {
            title: 'Создание джекпота',
        }
    },
    {
        path: '/jackpot/edit/:id/:parentQuery?',
        component: JackpotEdit,
        name: 'JackpotEdit',
        props: true,
        meta: {
            title: 'Редактирование джекпота',
        }
    },
    {
        path: "*",
        component: pageNotFound,
        name: 'pageNotFound',
        meta: {
            title: '404',
        }
    },
];

const Router = new VueRouter({
    routes,
    mode: 'history',
    base: '/',
});
if (!!Router) {
    Router.beforeEach((to, from, next) => {
        try {
            if(!!from && !!from.params && !!from.params.parentQuery) {
                if(typeof from.params.parentQuery  === 'string') {
                    let parentQuery =  JSON.parse(from.params.parentQuery);
                    for (const [key, value] of Object.entries(parentQuery)) {
                        to.query[key] = value;
                    }
                }
            }
            next();
        } catch (e) {
            console.log(e);
        } finally {
            next();
        }
    });
}

const app = new Vue({
    el: '#app',
    store,
    vuetify: new Vuetify({
        theme: { dark: true },
    }),
    router: Router,
});
